import type {
  CreateJobDraftPayload,
  UpdateJobDraftPayload,
} from "@js/types/jobs";

export const isUpdateJobDraftPayload = (
  payload: UpdateJobDraftPayload | CreateJobDraftPayload,
): payload is UpdateJobDraftPayload =>
  "id" in payload.data && !!payload.data.id;
